import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import UploadCenter from "@/pages/UploadCenter";
import CapsuleBuilder from "@/pages/CapsuleBuilder";
import EncryptionSequence from "@/pages/EncryptionSequence";
import CommandCenter from "@/pages/CommandCenter";
import SpaceVault from "@/pages/SpaceVault";
import FamilyVault from "@/pages/FamilyVault";
import LegacyMode from "@/pages/LegacyMode";
import GlobalMap from "@/pages/GlobalMap";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import GalacticNav from "@/pages/GalacticNav";
import Verify from "@/pages/Verify";
import VerifyCertificate from "@/pages/VerifyCertificate";
import { Toaster } from "sonner";

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/upload" element={<Protected><UploadCenter /></Protected>} />
            <Route path="/capsule" element={<Protected><CapsuleBuilder /></Protected>} />
            <Route path="/galaxy" element={<Protected><GalacticNav /></Protected>} />
            <Route path="/encrypt/:tid" element={<Protected><EncryptionSequence /></Protected>} />
            <Route path="/transmission/:tid" element={<Protected><CommandCenter /></Protected>} />
            <Route path="/vault" element={<Protected><SpaceVault /></Protected>} />
            <Route path="/family" element={<Protected><FamilyVault /></Protected>} />
            <Route path="/legacy" element={<Protected><LegacyMode /></Protected>} />
            <Route path="/globe" element={<GlobalMap />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/verify/cert/:cid" element={<VerifyCertificate />} />
            <Route path="/verify/:tid" element={<Verify />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}
